export const EMAIL = { display: 'Email', value: 'EMAIL' };
export const TEXT = { display: 'Text', value: 'TEXT' };
export const NUMBER = { display: 'Number', value: 'NUMBER' };
export const DATE = { display: 'Date', value: 'DATE' };
export const SELECT = { display: 'Select', value: 'SELECT' };
export const CHECKBOX = { display: 'Checkbox', value: 'CHECKBOX' };
export const RADIO = { display: 'Radio', value: 'RADIO' };
export const COLOR = { display: 'Color', value: 'COLOR' };
export const TEXTAREA = { display: 'Textarea', value: 'TEXTAREA' };
